export function getRootDomain(): string {
	const hostname = window.location.hostname;
	const segments = hostname.split('.');
	return segments.length > 1
		? `${segments[segments.length - 2]}.${segments[segments.length - 1]}`
		: hostname;
}

export function getUrlParamByKey(paramKey: string): null | string {
	const urlParams = new URLSearchParams(window.location.search);

	return urlParams.get(paramKey);
}
